<template>
  <div>
    <div class='theme-border mb8' style='padding: 10px'>
      <el-form :model='formData' label-position='right' label-width='88px' label-suffix='：'>
        <el-row>
          <el-col :span='12'>
            <el-form-item label='组织' prop='org_name'>
              <el-select
                v-model='formData.org_name'
                filterable
                allow-create
                default-first-option
                style='width: 80%'
                placeholder='可选可自建(最多20个字符)' clearable>
                <el-option
                  v-for='item in options'
                  :key='item.value'
                  :label='item.label'
                  :value='item.value'>
                </el-option>
              </el-select>

              <el-link type='primary' icon='el-icon-refresh' @click='handleChangeOrg'
                       :title='`同步组织名“${formData.org_name}”给提报记录`' style='margin-left: 10px'></el-link>
              <!--              <el-input  v-model='formData.org_name' placeholder='组织名称，比如 缇苏|清澜' clearable></el-input>-->
            </el-form-item>
          </el-col>
          <!--          <el-col :span='12'>-->
          <!--            <el-form-item label='排序值'>-->
          <!--              <el-input-number v-model='formData.order' placeholder='排序值越小排越前面'></el-input-number>-->
          <!--              <span style='margin-left: 10px;color: #f0c78a'><i class='el-icon-info'></i>排序值越小排越前面</span>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
        </el-row>

        <el-row>
          <el-col :span='12'>
            <el-form-item label='刊例标题'>
              <el-input v-model='formData.title' placeholder='刊例标题' clearable />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='副标题'>
              <el-input v-model='formData.sub_title' placeholder='副标题' clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span='12'>
            <el-form-item label='开始日期'>
              <el-date-picker
                v-model='formData.validity_date'
                type='date'
                format='yyyy年MM月dd日'
                value-format='yyyy-MM-dd'
                placeholder='有效期：开始日期'>
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='截止日期'>
              <el-date-picker
                v-model='formData.expiry_date'
                type='date'
                format='yyyy年MM月dd日'
                value-format='yyyy-MM-dd'
                placeholder='有效期：截止日期'>
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label='合作须知'>
          <template slot='label'>
            <el-tooltip content='点击同步上期《合作须知》' placement='top'>
              <el-button type='text' @click='handleLastSync' :disabled='syncLoading'
                         :loading='syncLoading' style='font-size: 13px;font-weight: bolder'>合作须知：<span class='el-icon-info'></span>
              </el-button>
            </el-tooltip>
          </template>
          <div class='theme-border' style='min-height: 100px'>
            <ApeEditor
              :editorHeight='400'
              v-if='editorInit'
              :inline='true'
              :init-html='formData.notice'
              :toolbar="'undo redo paste | bold italic underline strikethrough | fontselect fontsizeselect |  forecolor backcolor | ' +
                'ltr rtl | alignleft aligncenter alignright alignjustify | bullist numlist' +
                ' | outdent indent blockquote | removeformat anchor hr |' +
                ' code preview fullscreen'"
              @handleTinymceInput='handleTinymceInput'></ApeEditor>
          </div>

        </el-form-item>
        <el-row>
          <el-col :span='12'>
            <el-form-item label='工作簿'>
              <template slot='label' >
                <el-tooltip content='刊例导出的excel工作空间名称，如不填写，则不导出该刊例基本及其提报记录。工作簿名称同刊例封面（合作须知）中设置，例如 抖音=》抖音KOL' placement='top' effect='light'>
                  <div slot="content">1、刊例导出的excel工作空间名称，如不填写，则不导出该刊例基本及其提报记录。<br/>
                    2、工作簿名称同刊例封面（合作须知）中设置，例如 抖音=》抖音KOL<br/>
                    3、模板沿用规则：继承上期的同组织同工作簿（刊例类型）的封面模板
                  </div>
                  <el-button type='text' style='font-size: 13px;font-weight: bolder'>工作簿：<span class='el-icon-info'></span></el-button>

                </el-tooltip>
              </template>
              <el-input v-model='formData.sheet_title' placeholder='工作簿名称（封面的工作簿名称一致，则可点击跳转）'
                        clearable />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='创建时间'> {{ formData.created_at || '' }}</el-form-item>

          </el-col>
          <el-col :span='12'>
            <el-form-item label='修改时间'>{{ formData.updated_at || '' }}</el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>

    <div style='text-align: center'>
      <el-button size='medium' type='primary' @click='saveInfo' :disabled='loading' :loading='loading' round>
        保存-基本信息
      </el-button>
    </div>

    <div class='default-toolbar' style='display: none'>
      <el-link type='primary' @click='showHtmlJson'>查看合作须知富文本JSON</el-link>
    </div>
    <div v-if='showRichTextJSON'>
      <JsonDisplay v-model='formData.notice_rich'
                   title='合作须知-富文本转JSON'
                   :show-copy='true'
                   :show-format='true'
                   :show-char-count='true'
                   :bordered='false'
                   copy-text='复制'></JsonDisplay>

    </div>

  </div>
</template>

<script>
import ApeEditor from '@/components/ApeEditor'
import { html2json } from 'html2json'
import JsonDisplay from '@/components/display/JsonDisplay.vue'
import { syncOrgToItems } from '@/api/plc'


export default {
  components: { JsonDisplay, ApeEditor },
  name: 'PlcBaseEdit',
  data() {
    return {
      id: null,
      formData: {
        id: null,
        pm_id: null,
        validity_date: null,
        expiry_date: null,
        notice: null,
        title: null,
        sub_title: null,
        sheet_title: null,
        org_name: null,
        order: 0
      },
      loading: false,
      editorInit: false,
      syncLoading: false,
      showRichTextJSON: false,
      options: [
        {
          value: '缇苏',
          label: '缇苏'
        },
        {
          value: '青澜',
          label: '青澜'
        }
      ]
    }
  },
  methods: {
    async show(id) {
      // 刊例ID（该平台类型的刊例ID-plc表ID）
      this.id = id
      this.formData = {}
      this.editorInit = true
      await this.getInfo()
    },
    //编辑器
    handleTinymceInput(val) {
      this.formData.notice = val
      //
    },
    async getInfo() {
      const { info } = await this.$api.getPublicationInfo(this.id)
      this.formData = info || {}
      this.$nextTick(() => {
        setTimeout(() => {
          if (!this.formData.notice) {
            this.handleLastSync()
          }
        }, 500)
      })
    },
    async handleLastSync() {
      this.syncLoading = true
      //根据刊例提报主ID-获取上期的信息
      const { info } = await this.$api.getPublicationLast(this.formData.id)
      if (info.notice) {
        this.handleTinymceInput(info.notice)
      }
      setTimeout(() => {
        this.syncLoading = false
      }, 500)

    },
    showHtmlJson() {
      this.showRichTextJSON = !this.showRichTextJSON
      this.formData.notice_rich = html2json(this.formData.notice)
    },
    async saveInfo() {
      this.loading = true
      const appendForm = { notice_rich: html2json(this.formData.notice) }
      const params = { ...this.formData, ...appendForm }
      // {
      //   id: this.formData.id,
      //   org_name: this.formData.org_name,
      //   pm_id: this.formData.pm_id,
      //   title: this.formData.title,
      //   sheet_title: this.formData.sheet_title,
      //   notice: this.formData.notice,
      //   expiry_date: this.formData.expiry_date,
      //   validity_date: this.formData.validity_date,
      //   order: this.formData.order,
      //   notice_rich: html2json(this.formData.notice)
      // }

      const id = await this.$api.savePublicationInfo(params)

      if (id) {
        this.editorInit = false

        this.$notify.success('保存成功')
        // await this.getInfo()
        this.$emit('saved')
      }
      this.loading = false
    },
    async handleChangeOrg() {
      this.$confirm('此操作将同步操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        //同步org给提报信息
        await syncOrgToItems(this.formData.id, this.formData.org_name)
        this.$notify.success('已同步成功，请刷新提报记录确认！！！')
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消同步'
        })
      })


    }
  }

}
</script>

<style scoped>

</style>
